import { useQuery } from "react-query";
import { planApi } from "@/react/api";

interface UseFetchProrationProps {
  enabled?: boolean;
  new_plan_id: number;
  only_ch?: boolean;
  plan_coupon_id?: string;
}

interface UseQueryFetchProration {
  prorationData: any;
}
interface UseFetchProrationResult extends UseQueryFetchProration {
  errorFetchingProration: any; // [TODO][BillingReactification][AfterRelease] Create error type
  isProrationLoading: boolean;
}
export const useFetchProration = ({
  new_plan_id,
  plan_coupon_id = "",
  only_ch,
  enabled = true,
}: UseFetchProrationProps): UseFetchProrationResult => {
  const queryKey = ["proration", new_plan_id, plan_coupon_id, only_ch];

  const {
    data,
    isLoading: isProrationLoading,
    error: errorFetchingProration,
  } = useQuery<UseQueryFetchProration, Error>(
    queryKey,
    () => planApi.proration({ new_plan_id, plan_coupon_id, only_ch }),
    { enabled },
  );

  const prorationData = data ?? {};

  return {
    prorationData,
    isProrationLoading,
    errorFetchingProration,
  };
};
